
<div class="container-fluid no-padding">

  <div class="row m-0 bg1">
    <div class="col-12" style="padding: 0; position: relative;">
      <!-- <img src="assets/images/banner.svg" style="width: 100%; min-height: 220px; object-fit: cover; max-height: 600px;"> -->

      <div style="position: absolute; bottom: 23%; left: 50px; color: white;">
        <div class="d-none d-lg-block">
          <h1 style="color: #73954a; font-size: 44pt !important; margin-bottom: 30px;">Reflect. Orient. Grow.</h1>
          <p style="font-size: 21pt; max-width: 600px;">Reflexis is a platform for meaningful
            competency reflection across
            practice, training, and research.</p>
        </div>
        <div class="d-none d-md-block d-lg-none">
          <h1 style="color: #73954a; font-size: 36pt !important;">Reflect. Orient. Grow.</h1>
          <p style="font-size: 18pt; max-width: 500px;">Reflexis is a platform for meaningful
            competency reflection across
            practice, training, and research.</p>
        </div>
        <div class="d-block d-md-none d-lg-none">
          <h1 style="color: #73954a; font-size: 28pt !important;">Reflect. Orient. Grow.</h1>
          <p style="font-size: 16pt; max-width: 500px;">Reflexis is a platform for meaningful
            competency reflection across
            practice, training, and research.</p>
        </div>
      </div>

    </div>
  </div>
  <div class="home-section" style="background-color: #FCFBF8;">
    <div class="row m-0">
      <div class="col-12 col-lg-6">
        <div style="padding: 0px 15px; text-align: center;" class="d-block d-lg-none">
          <img src="assets/images/home1.png" style="max-height: 50vh; min-height: 300px; max-width: 100%;">
        </div>
        <div style="padding: 0px 15px;" class="d-none d-lg-block">
          <img src="assets/images/home1.png" style="width: 100%; min-height: 300px;">
        </div>

      </div>
      <div class="col-12 col-lg-6">
        <div class="flexv">
          <p class="largetext">Whether you're a supervisor, trainee,
            or practising professional, Reflexis
            helps you reflect on professional
            development holistically and map
            a clear path forward.</p>
          <p class="text2">Use our standardised measures to clarify your
            strengths, identify areas for development, and
            create an actionable plan — all grounded in national
            standards and backed by research.</p>
        </div>

      </div>
    </div>
  </div>

  <div class="home-section" style="background-color: #EAEEF4; text-align: center;">
    <h2 class="alt-h" style="margin-bottom: 40px; margin-top: 20px;">Why Reflexis is different</h2>
    <div style="max-width: 75vw; margin: auto;">
      <div class="row" style="padding: 20px;">
        <div class="col-12 col-sm-6 col-lg-4" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_01.svg" alt="">
            <h4>Dual perspective
              assessment</h4>
            <p>The first platform to offer
              comprehensive self-assessment
              measures for trainees, placement
              students, and experienced
              practitioners.</p>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_02.svg" alt="">
            <h4>Identify strengths and
              development priorities</h4>
            <p>Move beyond a deficit-focus
              to recognise demonstrated
              competencies whilst pinpointing
              strategic areas for professional
              growth.</p>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_03.svg" alt="">
            <h4>Aligned with national
              standards</h4>
            <p>Our measures are developed to
              align with established professional
              standards, ensuring relevance,
              credibility, and transferability across
              practice contexts.</p>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_04.svg" alt="">
            <h4>Research-backed and
              evaluated</h4>
            <p>Developed through evidence-based
              methodology and subject
              to ongoing evaluation to ensure
              validity and utility.</p>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_05.svg" alt="">
            <h4>Holistic, multi-dimensional
              assessment</h4>
            <p>Capture competency across
              numerous practice domains
              and dimensions, providing a
              comprehensive snapshot of
              professional capability.</p>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_06.svg" alt="">
            <h4>Discipline-specific tools</h4>
            <p>Measures available across multiple
              professional disciplines, with
              continued expansion underway.</p>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_07.svg" alt="">
            <h4>Facilitate evidence-based
              professional growth</h4>
            <p>Transform reflection into purposeful
              action with clarity, confidence, and
              strategic direction.</p>
          </div>
        </div>

        <div class="col-12 col-lg-8" style="padding: 20px; display: flex; align-items:center;">
          <h3 style="font-size: 18pt; color: #004051;">“Reflexis supports meaningful, evidence-based
            competency reflection for practitioners, universities,
            and organisations, strengthening professional
            growth, learning outcomes, and career readiness.”</h3>
        </div>


      </div>
    </div>

  </div>

  <div class="home-section bg2" style="text-align: center;">
    <h2 class="alt-h" style="margin-bottom: 40px; color: #BAD677; margin-top: 20px;">The impact of Reflexis</h2>
    <div style="max-width: 75vw; margin: auto;">
      <div class="row" style="padding: 20px;">
        <div class="col-12 col-md-6" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_08.svg" alt="">
            <h4>For Practitioners:</h4>
            <p>Gain clarity on your professional strengths and development
              priorities through meaningful reflection. Build evidence of
              your competency growth across your career trajectory. Make
              informed decisions about your professional development
              with confidence and strategic direction.</p>
          </div>
        </div>
        <div class="col-12 col-md-6" style="padding: 20px;">
          <div class="box">
            <img src="/assets/images/Icon_09.svg" alt="">
            <h4>For Organisations, Universities & Health Services:</h4>
            <p>Embed standardised, efficient competency reflection into
              your training pathways, placements and staff professional
              development. Support student and staff development with
              evidence-based tools aligned to national standards. Strengthen
              placement quality, learning outcomes, and professional
              readiness across your organisation.</p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="home-section" style="background-color: #FBF9F4; text-align: center;">
    <div class="row m-0" style="padding-bottom: 40px;">
      <div class="col-12">
        <h2 class="alt-h" style="margin-bottom: 40px; margin-top: 40px;">Assessment tools</h2>
        <p style="margin-bottom: 50px; font-size: 15pt;">Please select your discipline below to explore the assessment
          tools available for your practice.</p>
        <a routerLink="/coppr" routerLinkActive="active" class="btn btn-white"
          style='margin: 15px; width: 240px;'>Psychology</a>
        <a href="" class="btn btn-white" style='margin: 15px; width: 240px;'>Other disciplines</a>
      </div>
    </div>
  </div>

  <div class="home-section bg3">
    <div class="row m-0">
      <div class="col-12 col-lg-6">
        <div style="padding: 0px 15px; text-align: center;" class="d-block d-lg-none">
          <img src="assets/images/home2.png" style="max-height: 50vh; min-height: 300px; max-width: 100%;">
        </div>
        <div style="padding: 0px 15px;" class="d-none d-lg-block">
          <img src="assets/images/home2.png" style="width: 100%; min-height: 300px;">
        </div>

      </div>
      <div class="col-12 col-lg-6">
        <div class="flexv">
          <h2 class="alt-h" style="margin-bottom: 40px; color: white; margin-top: 30px;">About Reflexis</h2>
          <p class="text2" style="color: white;">Reflexis is an innovation of the Thrive Research
            Centre at the University of New England.</p>
          <p class="text2" style="color: white;">Universities, health services, and organisations
            seeking to integrate Reflexis across their courses,
            placements, and training programs are encouraged
            to contact us regarding large-scale adoption and
            implementation support.</p>
        </div>

      </div>
    </div>
  </div>
  <div class="home-section" style="padding-bottom: 30px;">
    <div class="row m-0" style="padding: 20px 30px;">
      <div class="col-12 col-lg-4" style="border-left: 1px solid; padding-left: 40px;">
        <img src="assets/images/logo2.png" class="flogo" style="margin-left: -13px; padding: 5px 0px;">
        <p class="rubik-medium" style="font-size: 11pt;">For inquiries or collaborations, please <a
            routerLink="/contact-us" routerLinkActive="active" style="color: unset;">Contact Us.</a></p>
        <address class="rubik-light" style="font-size: 11pt;">
          Associate Professor Kylie Rice<br>
          Executive Director, Thrive Research Centre<br><br>

          Faculty of Medicine and Health<br>
          University of New England<br><br>

        </address>
      </div>
      <div class="col-12 col-lg-4" style="border-left: 1px solid; padding-left: 40px;">
        <img src="assets/images/UNE_Logo.png" class="flogo">
        <p class="rubik-medium" style="font-size: 11pt;">Research by:</p>
        <address class="rubik-light" style="font-size: 11pt;">
          University of New England<br>
          Armidale NSW 2351 Australia<br><br>
          <a class="rubik-medium" href="https://une.edu.au" target="_blank" style="color: unset;">une.edu.au</a>
        </address>
      </div>
      <div class="col-12 col-lg-4" style="border-left: 1px solid; padding-left: 40px;">
        <img src="assets/images/UNE_CASI_Logo.png" class="flogo">
        <p class="rubik-medium" style="font-size: 11pt;">Dashboard developed by:</p>
        <address class="rubik-light" style="font-size: 11pt;">
          UNE CASI (Computation, Analytics,
          Software, Informatics)<br>
          University of New England<br>
          Armidale NSW 2351 Australia<br><br>
          <a class="rubik-medium" href="https://casi.une.edu.au" target="_blank"
            style="color: unset;">casi.une.edu.au</a>
        </address>
      </div>
    </div>

  </div>


</div>
